var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"as-page"},[_c(_vm.$route.meta.layout || 'div',{tag:"component"},[_c('router-view')],1),_c('consent-banner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }